import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// Models
import { AdminPostTypes, PostTypes } from "./../../models/post-types";
import * as lodash from "lodash";

import { Attachment } from "./../../models/attachment";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { OAuthService } from "app/services/o-auth";
import { environment } from '../../../environments/environment';

@Component({
  templateUrl: "./create.post.everyone.component.html",
  styleUrls:["./create.post.everyone.component.css"],
})
export class CreatePostEveryoneComponent implements OnInit {
  public post: any;
  public disabled: boolean;
  public loading: boolean;
  public postId;
  public attachment: Attachment;
  private attachmentExt: string;
  DesktopView: boolean = false;
  public file: File;
  public thumbnail: String;
  public postTypes: Array<{ value: string; name: string }>;
  public club: any;

  constructor(
    private router: Router,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private changeDetector: ChangeDetectorRef
  ) {
    this.disabled = true;
    this.loading = false;
    this.club = this.oAuthService.getClub();

    this.post = {
      notification: true,
      commentsCount: 0,
      likesCount: 0,
      liked: false,
      type: "a0",
      isGeneral: true,
      userId: this.club.uid,
      uid: this.club.cid,
      postType: 1,
    };
    this.postTypes = [];
  }
  onTypeChange(event)
  {
    this.post.postType = +this.post.postType;
    this.initilizeSummernote();
  }

   fileChangeEvent(event: any): void {
        if (!event.target.files.length) {
            return;
        }
        this.file = event.target.files.item(0);

        if (this.file.type.match('video')) 
        {
            var _CANVAS = <HTMLCanvasElement>document.querySelector("#video-canvas"),
                _CTX = _CANVAS.getContext("2d"),
                _VIDEO = <HTMLVideoElement>document.querySelector("#main-video");
            // Object Url as the video source
            document.querySelector("#main-video source").setAttribute('src', URL.createObjectURL(this.file));
            _VIDEO.currentTime = 1

            // Load the video and show it
            _VIDEO.load();
            _VIDEO.style.display = 'inline';
            // Load metadata of the video to get video duration and dimensions
            _VIDEO.addEventListener('loadedmetadata', function () {
                var video_duration = _VIDEO.duration,
                    duration_options_html = '';

                // Set options in dropdown at 4 second interval
                for (var i = 0; i < Math.floor(video_duration); i = i + 4) {
                    duration_options_html += '<option value="' + i + '">' + i + '</option>';
                }


                _CANVAS.width = _VIDEO.videoWidth;
                _CANVAS.height = _VIDEO.videoHeight;


            });

            setTimeout(() => {
                // _CTX.drawImage(_VIDEO, 0, 0, _VIDEO.videoWidth, _VIDEO.videoHeight);
                var dataURI = _CANVAS.toDataURL()

                var byteString = atob(dataURI.split(',')[1]);

                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);

                // create a view into the buffer
                var ia = new Uint8Array(ab);

                // set the bytes of the buffer to the correct values
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
              var blob = new Blob([ab], { type: mimeString });
               blob =new Blob([ab], { type: mimeString });
          
                this.uploadVideoInMagazine = {
                    file: this.file,
                    type: 'video',
                    width: `${environment.magazine_image_width}`,
                    // height: `${environment.magazine_image_height}`,
                    thumbnail: blob
                }
            }, 2000)
        }
  }
 
  ngOnInit(): void {
    console.log(this.club);
    this.postId = this.fireDatabase.database
      .ref(`/users-posts/${this.post.author}`)
      .push().key;
    
    if (this.club.type == 3) {
      lodash.forEach(AdminPostTypes, (type, key) => {
        this.postTypes.push({ value: key, name: type[0] });
      });
    } else if(this.club.type == 1){
      lodash.forEach(PostTypes, (type, key) => {
        this.postTypes.push({ value: key, name: type[0] });
      });
    }else {
      let typename = "company-insights";
      switch (this.club.type) {
        case 5:
          typename = "company-insights";
          break;
        case 6:
          typename = "society-insights";
          break;
        case 7:
          typename = "tour-insights";
          break;
        case 5:
          typename = "company-insights";
          break;
      }

      this.fireDatabase.object(`/master/${typename}`).subscribe((data) => {
        let ids = Object.keys(data);
        this.fireDatabase.object(`/users/${this.club.cid}`).subscribe((d) => {
          this.postTypes = [];
          let assignedInsightsIds = [];
          if (d.insights) {
            let i = Object.keys(d.insights);
            i.map((x) => {
              if (d.insights[x] == 1) {
                assignedInsightsIds.push(x);
              }
            });
          }
          ids.map((x, index) => {
            let y = assignedInsightsIds.findIndex((y) => y == x);
            if (y != -1) {
              this.postTypes.push({ value: String(index), name: data[x].name });
            }
          });
          if (this.postTypes[0]) {
            this.post.type = this.postTypes[0].value;
          }
        });
      });
    }
  }
  videoSource;
  public changeAttachment(attachment: Attachment): void {
    this.videoSource = undefined
    this.attachment = attachment;
    console.log("this.attachment",this.attachment);
    if (this.attachment) {
      this.attachmentExt = this.attachment.file.name.split(".").pop();
      this.disabled = false;
      let self = this
      var reader = new FileReader();
      reader.onload = function(e) {
        $('.myvideo').attr('src', (<FileReader>e.target).result);
        console.log("result", (<FileReader>e.target).result)
        self.videoSource = (<FileReader>e.target).result
      };
      reader.readAsDataURL(this.attachment.file);
    } else {
      this.attachmentExt = "";
      this.disabled = true;
    }
  }

  public changeTextMentioned(data: {
    text: string;
    mentioned: Array<any>;
  }): void {
    this.changeText(data.text);
    this.changeMentioned(data.mentioned);
  }

  public changeText(text: string): void {
    this.post.text = text;

    if (this.post.text) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }

  public changeMentioned(users: Array<any>): void {
    if (users.length) {
      this.post.mentioned = {};

      users.forEach((user) => {
        this.post.mentioned[user.$key] = {
          username: user.username,
          type: user.type,
        };
      });
    }
  }

  private uploadFile(): Promise<any> {
    // console.log(this.attachment)
    return new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/posts/${this.post.author}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => {
            if (this.attachment.type == "video") {
              const filename1 = `${moment().unix()}.${Math.floor(
                Math.random() * 900 + 100
              )}.${this.attachmentExt}`;
              this.firebase
                .storage()
                .ref(`/posts/${this.post.author}`)
                .child(filename1)
                .put(this.attachment.thumbnail)
                .then((res) => {
                  // console.log(res)
                  this.thumbnail = res.downloadURL;
                  resolve(result);
                });
            } else {
              resolve(result);
            }
          })

          .catch((error) => reject(error));
      } else {
        return resolve(true);
      }
    });
  }

  initilizeSummernote()
  {
    let self = this
     $(document).ready(function () {
      $('#summernote').summernote({
        airMode: false,
        tabDisable: true,
        popover: {
          table: [
            ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
            ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
          ],
          image: [
            ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
            ['float', ['floatLeft', 'floatRight', 'floatNone']],
            ['remove', ['removeMedia']]
          ],
          link: [
            ['link', ['linkDialogShow', 'unlink']]
          ],
          air: [
            [
              'font',
              [
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'superscript',
                'subscript',
                'clear'
              ]
            ],
          ]
        },
        height: '200px',  
        uploadImagePath: '/api/upload',
        toolbar: [
          ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
          [
            'font',
            [
              'bold',
              'italic',
              'underline',
              'strikethrough',
              'superscript',
              'subscript',
              'clear'
            ]
          ],
          ['color', ['color'],['color']],
          ['fontsize', ['fontname', 'fontsize', 'color']],
          ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
          ['insert', ['table', 'picture', 'link', 'hr']],
          // ['insert', ['table', 'picture', 'link', 'video', 'hr']],

          // ['myButton', ['myVideo', 'insertPDF']] //custom button
          ['myButton', ['myVideo']]
        ],
        foreColor:'white',
        buttons:
        {
          myVideo: function (context)
          {
            var ui = $.summernote.ui;
            var button = ui.button({
              contents: '<i class="fa fa-video-camera"/>',
              tooltip: 'video',
              click: async function () {
                self.storedContext = context
                self.showVideoInsertPopup();
              }
            });

            return button.render();
          },
          insertPDF: function (context)
          {
            var ui = $.summernote.ui;
            var button = ui.button({
              contents: '<i class="fa fa-file-pdf-o"/>',
              tooltip: 'insert PDF',
              click: async function () {
                self.storedContext = context
                self.showPopup();
              }
            });

            return button.render();
          }
        },
        codeviewFilter: false,
        codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    
        codeviewIframeFilter: false,
        callbacks:
        {
              
              onImageUpload: function (files) {

                if (!files.length) return;
            var file = files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    this.thumbnail = reader.result;

                    const image = new Image();
                    image.src = this.thumbnail;
                  this.imgSrc = image.src;
                    image.onload = () => {
                        let img ={
                            file: file,
                            width: image.width,
                            height: image.height,
                            type: 'image',
                            thumbnail:this.thumbnail
                        }
                      self.uploadImage(img);
                    };
                };
              },
          onChange: function (contents, $editable) {
            self.post.detailText = contents;
            self.imageSrcs = self.getImages(self.post.detailText);
            self.iframeSrss = self.getIframes(self.post.detailText);
            self.changeDetector.detectChanges();
          },
              onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window['clipboardData']).getData('Text');
                e.preventDefault();
                document.execCommand('insertText', false, bufferText);
                   $("#summernote").summernote("foreColor", "white"); 
          },
          onImageLinkInsert: function (url) {
                $("#summernote").summernote("foreColor", "white"); 
            // url is the image url from the dialog
                  // let img = $('<img>').attr({ src: url, width:environment.magazine_image_width, height: environment.magazine_image_height})
                 let img = $('<img>').attr({ src: url, width:environment.magazine_image_width})
                $('#summernote').summernote('insertNode', img[0]);
                $("#summernote").summernote("foreColor", "white"); 
          }
        }
      });
        //set background colour of text
      //  $("#summernote").summernote("backColor", "transparant"); 
        // set foreground color 
        $("#summernote").summernote("code", self.post.detailText);
      $("#summernote").summernote("foreColor", "white"); 
   

    });
  }

  
  getImages(string) {
  const imgRex = /<img.*?src="(.*?)"[^>]+>/g;
  const images = [];
    let img;
    while ((img = imgRex.exec(string))) {
     	images.push(img[1]);
    }
  return images;
  }
  getIframes(string) {
  const imgRex = /<iframe.*?src="(.*?)"[^>]+>/g;
  const images = [];
    let img;
    while ((img = imgRex.exec(string))) {
     	images.push(img[1]);
    }
  return images;
}
///////////// video upload custm button
  uploadVideoInMagazine: any;
  storedContext: any;
  showLoadingVideo = false;
  imageSrcs: any = [];
  iframeSrss: any=  [];
  showVideoInsertPopup()
  {
    this.uploadVideoInMagazine = undefined;
    $('#videoUpload').modal('show');
  }

  showPopup()
  {
    this.uploadVideoInMagazine = undefined;
    $('#docUpload').modal('show');
  }

  hidePopup()
  {
    $('#videoUpload').modal('hide');
    $('#docUpload').modal('hide');
  }

  async  getVideoUrl(videUrl)
  {
    if (!videUrl) return
    $("#summernote").summernote("foreColor", "white"); 
    let context = this.storedContext
    var div = document.createElement('div');
              div.classList.add('embed-container');
              var iframe = document.createElement('iframe');
              iframe.src = videUrl
              iframe.setAttribute('frameborder', '0');
              iframe.setAttribute('width', `${environment.magazine_image_width}`);
              // iframe.setAttribute('height', `${environment.magazine_image_height}`);
              iframe.setAttribute('allowfullscreen', 'true');
              context.invoke('editor.insertNode', iframe);
              $("#summernote").summernote("foreColor", "white"); 
  }



  onUploadVideo(event)
  {
    this.getVideoUrl1().then((result: any) => {

      this.firebase.storage().ref(result.metadata.fullPath).getDownloadURL().then((result) => {
        this.getVideoUrl(result);
      });
    });
  }



  uploadImage(file)
  {
    $("#summernote").summernote("foreColor", "white");
    this.getImageUrl(file).then((result:any) => {
      this.firebase.storage().ref(result.metadata.fullPath).getDownloadURL().then((url) => {
        let img = $("<img>").attr({ src: url, width:environment.magazine_image_width}); // << Add here img attributes !
        // let img = $("<img>").attr({ src: url, width:environment.magazine_image_width, height: environment.magazine_image_height}); // << Add here img attributes !
        $('#summernote').summernote("insertNode", img[0]);
         $("#summernote").summernote("foreColor", "white"); 
      });
      
    })
    
  }

  async getVideoUrl1()
  {
    this.showLoadingVideo = true;
    return new Promise((resolve, reject) => {
          if (this.uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${this.uploadVideoInMagazine.file.name.split(".").pop()}`;
            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(this.uploadVideoInMagazine.file)
              .then((result) => {
                console.log(result)
                if (this.uploadVideoInMagazine.type == "video") {
                  const filename1 = `${moment().unix()}.${Math.floor(
                    Math.random() * 900 + 100
                  )}.${this.uploadVideoInMagazine.file.name.split(".").pop()}`;
                  this.firebase
                    .storage()
                    .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
                    .child(filename1)
                    .put(this.uploadVideoInMagazine.thumbnail)
                    .then((res) => {
                      console.log("uploaded", res)
                      this.showLoadingVideo = false;
                      this.hidePopup();
                      resolve(result);
                    })
                  .catch((error) => { alert('Video Upload Failed..1');this.showLoadingVideo = false;this.hidePopup();reject(error) });
                } else {
                  this.hidePopup();
                  this.showLoadingVideo = false;
                  resolve(result);
                }
              })

              .catch((error) => { alert('Video Upload Failed..'); this.showLoadingVideo = false;this.hidePopup();reject(error) });
          } else {
            this.showLoadingVideo = false;
            this.hidePopup();
            return resolve(true);
          }
        });
  }

  createDocUrl(uploadVideoInMagazine)
  {
    return new Promise((resolve, reject) => {
          if (uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${uploadVideoInMagazine.name.split(".").pop()}`;

            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(uploadVideoInMagazine)
              .then((result) => {

               resolve(result)
              })

              .catch((error) => { alert('Image Upload Failed..'); reject(error) });
          } else {
            return resolve("");
          }
        });
  }

   getImageUrl(uploadVideoInMagazine)
  {
    return new Promise((resolve, reject) => {
          if (uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${uploadVideoInMagazine.file.name.split(".").pop()}`;
            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(uploadVideoInMagazine.file)
              .then((result) => {
               resolve(result)
              })

              .catch((error) => { alert('Image Upload Failed..'); reject(error) });
          } else {
            return resolve("");
          }
        });
  }

  public submit(): void {
    this.post.author = this.club.cid;
    this.post.date = moment().unix();
    this.post.postType = +this.post.postType;

    if (this.post.postType == 1)
      this.post.detailText = ""
    if (this.post.postType == 2) {
      if ($('#summernote').summernote('isEmpty'))
      {
        alert('Please add magazine');
        return;
      }      
    }

    if (!this.post.text)
    {
      alert("Please add Message");
      return
    }
    if (!this.attachment ) {
      alert("Please Insert photo or video");
      return
    }
    this.disabled = true;
    this.loading = true;

    this.uploadFile()
      .then((fileResult) => {
        // console.log(fileResult)
        if (fileResult && fileResult.downloadURL) {
          if (fileResult.metadata.contentType.match("image")) {
            this.post.photo = {
              url: fileResult.downloadURL,
              width: this.attachment.width,
              height: this.attachment.height,
            };
          }

          if (fileResult.metadata.contentType.match("video")) {
            this.post.video = {
              url: fileResult.downloadURL,
              width: this.attachment.width,
              height: this.attachment.height,
            };
            this.post.video.thumbnailUrl = this.thumbnail;
          }
        }
        if (this.post.isGeneral) {
          delete this.post.type;
        }
        delete this.post.isGeneral;

        this.fireDatabase.database
          .ref(`/users-posts/${this.post.author}/${this.postId}`)
          .set(this.post)
          .then((postResult) => {
            if (this.club.type == 3) {
              this.fireDatabase.database
                .ref(`/server-process/post-admin/${this.postId}`)
                .set({
                  // userId: this.club.uid,
                  userId: this.club.cid,
                  offset: 0,
                });
            }
            this.fireDatabase.database.ref(`/user-portal-posts/${this.club.uid}/${this.club.cid}/`).child(this.postId).set(true).then(result => {
                  console.log("user-portal-posts succsessfull");
                  return this.router.navigate(["/pages/my-posts"]);
                }).catch(error=>{console.log("user portal post: ", error)})
            return this.router.navigate(["/components/postToEveryone"]);
          })
          .catch((error) => {
            this.error(error);
          });
      })
      .catch((error) => {
        this.error(error);
      });
  }

  private error(error): void {
    console.error(error);

    alert("Sorry, something went wrong!");

    this.disabled = false;
    this.loading = false;
  }
}
